export const SYSTEM_TEMPLATES_LABEL = 'Systémové šablony';
export const CUSTOM_REPLIES_LABEL = 'Vlastní odpovědi';
export const NO_MATCH_MESSAGE = 'Žádná šablona neodpovídá hledání';
export const EMPTY_GROUP_MESSAGE = 'Žádné šablony v této skupině';
export const RETRY_BUTTON_LABEL = 'Zkusit znovu';
